import { AutoComplete, Button, Card, Descriptions, Divider, Flex, Form, Grid, Image, message, Modal, Select, Typography } from "antd";
import { Icon } from "@iconify/react";
import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router";
import { registrationService } from "../../services/registration.service";
import RenderIf from "../../components/RenderIf";
import { userService } from "../../services/user.service";
import { API_BASE_URL } from "../../config/api.config";
import { cancelReason } from "../../utils/options.data";

export default function RegistrationDetail(){

  const navigate = useNavigate()

  const [acceptForm] = Form.useForm()
  const [rejectForm] = Form.useForm()

  const breakpoint = Grid.useBreakpoint()

  const [status, setStatus] = useState('')

  const [messageApi] = message.useMessage()

  const [previewImage, setPrevieImage] = useState('')

  const { id } = useParams()

  const { data: registration  } = useQuery({
    queryKey: ['detailRegistration', id],
    queryFn: () => registrationService.getById(id),
  })

  const { data: surveyor  } = useQuery({
    queryKey: ['surveyor', registration],
    queryFn: () => userService.getSurveyorByMarketing(),
  })

  const rejectMutation = useMutation({
    mutationKey: ['rejectMutation'],
    mutationFn: val => registrationService.reject(id, val),
    onSuccess: () => {
      messageApi.success("Data berhasil ditolak")
      return navigate("/registration/canceled")
    }
  })

  const acceptMutation = useMutation({
    mutationKey: ['acceptMutation'],
    mutationFn: val => registrationService.accept(id, val),
    onSuccess: () => {
      message.success("Data berhasil diterima")
      return navigate("/registration-pending")
    }
  })

  const handleReject = val => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin menolak sambungan ?",
      onOk: () => rejectMutation.mutate(val)
    }) 
  }

  const handleAccept = val => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin melanjutkan proses ?",
      onOk: () => acceptMutation.mutate(val)
    }) 
  }

  return (
    <>
      <Card
        title="Detail Registrasi"
      >
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Informasi Pelanggan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Pelanggan', children: registration?.data?.nama_kustomer },
            { label: 'No Telepon', children: registration?.data?.nomor_kustomer },
            { label: 'Email', children: registration?.data?.email_kustomer },
            { label: 'Kota', children: registration?.data?.kota_kustomer },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_kustomer },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_kustomer },
            { label: 'Jalan', children: registration?.data?.jalan_kustomer },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_kustomer },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_kustomer?.toString().padStart(3, "0") },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_kustomer?.toString().padStart(3, "0") },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          size="small"
          title="Penanggung Jawab"
          styles={{ label: { width: 200 } }}
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Penanggung Jawab', children: registration?.data?.nama_pic },
            { label: 'No Telepon', children: registration?.data?.nomor_pic },
            { label: 'Email', children: registration?.data?.email_pic },
            { label: 'Kota', children: registration?.data?.kota_pic },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_pic },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_pic },
            { label: 'Jalan', children: registration?.data?.jalan_pic },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_pic },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_pic?.toString().padStart(3, "0") },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_pic?.toString().padStart(3, "0") },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 180 } }}
          size="small"
          title="Informasi Bangunan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'Kebutuhan Air',
              children: registration?.data?.kebutuhan_air + 'm3'
            },
            { label: 'Ketersediaan Tangki', children: registration?.data?.ketersediaan_tangki },
            { label: 'Peruntukan Bangunan', span: 2, children: registration?.data?.peruntukan_bangunan },
            { label: 'Titik Lokasi Bangunan', span: 2, children: registration?.data?.alamat_bangunan },
          ]}
        />
        <Descriptions
          column={1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 110 }, content: { width: '100%' } }}
          size="small"
          title="Dokumen"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.ktp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.ktp}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.ktp}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'KK', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.kk}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.kk}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.kk}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.pbb}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.pbb}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'Bangunan', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.bangunan}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.bangunan}?download=true`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.bangunan}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
          ]}
        />
        <Divider/>
        <Flex key={'1'} justify="end" gap={12} >
          <Button 
            variant="outlined" 
            color="danger" 
            disabled={status.length > 0}
            onClick={() => setStatus('Reject') }
          >
            Tolak
          </Button>
          <Button 
            variant="solid" 
            color="primary"
            onClick={() => setStatus('Accept') }
            disabled={status.length > 0}
          >
            Terima
          </Button>
        </Flex>
        <RenderIf when={status == 'Accept'} >
          <Divider/>
          <Typography.Title level={5} style={{ marginTop: 20 }} >
            Terima Pendaftaran
          </Typography.Title>
          <Form
            form={acceptForm}
            layout="vertical"
            onFinish={handleAccept}
          >
            <Form.Item label="Assign Surveyor" name={'surveyorId'} rules={[{ required: true }]} >
              <Select
                options={surveyor?.data?.map(e => ({ value: e.id, label: e.name }))}
              />
            </Form.Item>
          </Form>
          <Flex key={'1'} justify="end" gap={12} style={{ marginTop: 28 }} >
            <Button 
              variant="outlined" 
              color="danger" 
              onClick={() => setStatus('') }
            >
              Batal
            </Button>
            <Button 
              variant="solid" 
              color="primary"
              onClick={() => acceptForm.submit() }
            >
              Submit
            </Button>
          </Flex>
        </RenderIf>
        <RenderIf when={status == 'Reject'} >
          <Divider/>
          <Typography.Title level={5} style={{ marginTop: 20 }} >
            Tolak Pendaftaran
          </Typography.Title>
          <Form
            form={rejectForm}
            layout="vertical"
            onFinish={handleReject}
          >
            <Form.Item label="Alasan Tolak" name={'reason'} rules={[{ required: true }]} >
              <AutoComplete
                options={cancelReason.map(e => ({ label: e, value: e }))}
                filterOption
              />
            </Form.Item>
          </Form>
          <Flex key={'1'} justify="end" gap={12} style={{ marginTop: 28 }} >
            <Button 
              variant="outlined" 
              color="danger" 
              onClick={() => setStatus('') }
            >
              Batal
            </Button>
            <Button 
              variant="solid" 
              color="primary"
              onClick={() => rejectForm.submit() }
            >
              Submit
            </Button>
          </Flex>
        </RenderIf>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={()=> setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <Image src={previewImage} />
      </Modal>
    </>
  )
}